// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3H5oR","list":"_2PFer","calendar":"UIxZy","sectionDateTitle":"_3-7x0","dateSectionDesktop":"_2zsPu","dateSectionMobile":"_2ijj4"};